exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3LeQQnRwf7YYxq2-oI8NIY{height:33px;font-size:14px;font-weight:400}", ""]);

// exports
exports.locals = {
	"findPeopleControl": "_3LeQQnRwf7YYxq2-oI8NIY"
};